import React from "react";
import { useTranslation } from "react-i18next";
import { ActionAndConfirm } from "common/ActionAndConfirm";
import { useEmailMarketingUnsubscribeCampaignRecipientMutation } from "__generated__/graphqlUnauthenticated";

interface IUnsubscribeProps {
  children?: React.ReactElement;
  onCompleted: () => void;
  emsUserToken: string;
}
export const Unsubscribe: React.FC<IUnsubscribeProps> = ({
  children,
  onCompleted,
  emsUserToken,
}) => {
  const { t: translate } = useTranslation("email_marketing");
  const [doUnsubscribe, { data, loading, error }] =
    useEmailMarketingUnsubscribeCampaignRecipientMutation({
      variables: {
        emsUserToken,
      },
      onCompleted: (data) => {
        const failReasons =
          data?.emailMarketingUnsubscribeCampaignRecipient?.failReasons || [];
        if (failReasons.length === 0) {
          onCompleted();
        }
      },
    });
  return (
    <ActionAndConfirm
      loading={loading}
      onRemove={doUnsubscribe}
      confirmTitle={translate("email_unsubscribe.confirm_title")}
      confirmContent={translate("email_unsubscribe.confirm_content")}
      errorMessage={
        error?.message ||
        data?.emailMarketingUnsubscribeCampaignRecipient?.failReasons[0]
      }
    >
      {children}
    </ActionAndConfirm>
  );
};
